import { createContext, useRef } from "react";
import PropTypes from "prop-types";

export const InAppBrowserIntentContext = createContext();

export const InAppBrowserIntentProvider = ({ children }) => {
  const intentTriggeredRef = useRef(false);

  return <InAppBrowserIntentContext.Provider value={intentTriggeredRef}>{children}</InAppBrowserIntentContext.Provider>;
};

InAppBrowserIntentProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
